<template>
<!-- Site wrapper -->
<div>
  <!-- Main content -->
  <section class="content">
    <!-- Default box -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body d-flex flex-column">
            <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
              <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
              <b-spinner class="ml-2" variant="danger"></b-spinner>
            </div>

            <form class="forms-sample">
              <div class="form-row">

                <div class="agrupamento col-xl-12 mt-4">
                    <div class="form-row col-xl-12">
                      <div class="form-group col-sm-12 col-md-12 col-lg-10 col-xl-11">
                        <label class="mt-2" for="inputAreas">Eventos</label>
                        <div class="form-row col-xl-12">

                          <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-3 ml-3">
                            <input
                              type="checkbox"
                              v-model="agenda.formulario.enableViewCustomerBirthdays"
                              class="custom-control-input"
                              id="customSwitch_viewCustomerBirthdays"
                              :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                            <label class="custom-control-label" for="customSwitch_viewCustomerBirthdays">Aniversários Clientes</label>
                          </div>

                          <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-3 ml-3">
                            <input
                              type="checkbox"
                              v-model="agenda.formulario.enableViewEventAppointments"
                              class="custom-control-input"
                              id="customSwitch_viewAppointments"
                              :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                            <label class="custom-control-label" for="customSwitch_viewAppointments">Prazos</label>
                          </div>

                          <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-3 ml-3">
                            <input
                              type="checkbox"
                              v-model="agenda.formulario.enableViewEventHearings"
                              class="custom-control-input"
                              id="customSwitch_viewHearings"
                              :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                            <label class="custom-control-label" for="customSwitch_viewHearings">Audiências</label>
                          </div>

                          <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-3 ml-3">
                            <input
                              type="checkbox"
                              v-model="agenda.formulario.enableViewEventActivities"
                              class="custom-control-input"
                              id="customSwitch_viewActivities"
                              :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                            <label class="custom-control-label" for="customSwitch_viewActivities">Atividades</label>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                <div class="col-sm-12 col-xl-12">
                  <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-3 mt-3">
                    <input
                      type="checkbox"
                      v-model="agenda.formulario.enableAutomatedInviteConfirmation"
                      class="custom-control-input"
                      id="customSwitch_inviteConfirmation"
                      :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                    <label class="custom-control-label" for="customSwitch_inviteConfirmation">Confirmar todos os aceites de convite automaticamente</label>
                  </div>
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.enableAutomatedInviteConfirmation}}</div>
                </div>

                <div class="col-sm-12 col-xl-12">
                  <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-3">
                    <input
                      type="checkbox"
                      v-model="agenda.formulario.enableAutomatedInviteAcceptance"
                      class="custom-control-input"
                      id="customSwitch_inviteAcceptance"
                      :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                    <label class="custom-control-label" for="customSwitch_inviteAcceptance">Aceitar todos os convites automaticamente</label>
                  </div>
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.enableAutomatedInviteAcceptance}}</div>
                </div>

                <div v-if="sincronizacaoCaldavPermitida || sincronizacaoICalPermitida" class="col-sm-12 col-xl-12">
                  <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-3">
                    <input
                      type="checkbox"
                      v-model="agenda.formulario.enableCaldavSync"
                      @change="habilitarOuDesabilitarCaldav"
                      class="custom-control-input"
                      id="customSwitch_caldav"
                      :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                    <label class="custom-control-label" for="customSwitch_caldav">Compartilhar agenda com outros aplicativos</label>
                  </div>
                  <div v-if="agenda.formulario.enableCaldavSync && !possuiContaCaldav" class="form-group col-sm-12 col-xl-12">
                    <label for="inputCaldavSenha">Informe sua senha atual</label>
                    <input type="password" v-model="agenda.formulario.f_caldav_password" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" autocomplete="off" class="form-control" id="inputCaldavSenha">
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_caldav_password}}</div>
                  </div>

                  <div v-if="agenda.formulario.enableCaldavSync && possuiContaCaldav" class="agrupamento col-xl-12 mt-4 ml-5">
                    <div class="form-row col-xl-12">
                      <div class="form-group col-sm-12 col-md-12 col-lg-10 col-xl-11">
                        <label class="mt-2 required" for="inputAreas">Eventos</label>
                        <div class="form-row col-xl-12">

                          <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-3 ml-3">
                            <input
                              type="checkbox"
                              v-model="agenda.formulario.enableViewSharingPersonal"
                              class="custom-control-input"
                              id="customSwitch_viewSharingPersonal"
                              :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                            <label class="custom-control-label" for="customSwitch_viewSharingPersonal">Pessoal</label>
                          </div>
                          <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-3 ml-3">
                            <input
                              type="checkbox"
                              v-model="agenda.formulario.enableViewSharingBirthdays"
                              class="custom-control-input"
                              id="customSwitch_viewSharingBirthdays"
                              :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                            <label class="custom-control-label" for="customSwitch_viewSharingBirthdays">Aniversários</label>
                          </div>

                          <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-3 ml-3">
                            <input
                              type="checkbox"
                              v-model="agenda.formulario.enableViewSharingAppointments"
                              class="custom-control-input"
                              id="customSwitch_viewSharingAppointment"
                              :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                            <label class="custom-control-label" for="customSwitch_viewSharingAppointment">Prazos</label>
                          </div>

                          <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-3 ml-3">
                            <input
                              type="checkbox"
                              v-model="agenda.formulario.enableViewSharingHearings"
                              class="custom-control-input"
                              id="customSwitch_viewSharingHearings"
                              :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                            <label class="custom-control-label" for="customSwitch_viewSharingHearings">Audiências</label>
                          </div>

                          <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-3 ml-3">
                            <input
                              type="checkbox"
                              v-model="agenda.formulario.enableViewSharingActivities"
                              class="custom-control-input"
                              id="customSwitch_viewSharingActivities"
                              :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                            <label class="custom-control-label" for="customSwitch_viewSharingActivities">Atividades</label>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="possuiContaCaldav && agenda.formulario.enableCaldavSync && sincronizacaoCaldavPermitida" class="agrupamento col-xl-12 ml-5 mt-4">
                    <div class="form-row col-xl-12">
                      <div class="form-group col-sm-12 col-md-12 col-lg-10 col-xl-11">
                        <label class="mt-2" for="inputAreas">Acesso no padrão CalDAV (acesso completo)</label>
                        <div class="form-group col-sm-12 col-xl-12 mt-2">
                          <label for="inputUriCaldav">Endereço</label>
                          <div class="input-group">
                            <input type="text" v-model="agenda.caldavData.url" readonly class="form-control" id="inputUriCaldav">
                            <div class="input-group-append">
                              <button type="button" class="btn btn-outline-secondary" @click="copiarTexto(agenda.caldavData.url)">
                                <span class="fa fa-copy"></span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="form-group col-sm-12 col-xl-12">
                          <label for="inputUsuarioCaldav">Usuário</label>
                          <input type="text" v-model="agenda.caldavData.username" readonly class="form-control" id="inputUsuarioCaldav">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="agrupamento col-xl-12 mt-4 ml-5" v-if="possuiContaCaldav && agenda.formulario.enableCaldavSync && sincronizacaoICalPermitida">
                    <div class="form-row col-xl-12">
                      <div class="form-group col-sm-12 col-md-12 col-lg-10 col-xl-11">
                        <label class="mt-2" for="inputAreas">Acesso no padrão iCal e WebCal (somente leitura)</label>
                        <div class="form-group mt-2 col-sm-12 col-xl-12">
                          <label for="inputUriIcal">Endereço</label>
                          <div class="input-group">
                            <input type="text" v-model="agenda.caldavData.urlIcalFeed" readonly class="form-control" id="inputUriIcal">
                            <div class="input-group-append">
                              <button type="button" class="btn btn-outline-secondary" @click="copiarTexto(agenda.caldavData.urlIcalFeed)">
                                <span class="fa fa-copy"></span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex align-items-center">
                  <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
                  <b-spinner class="ml-2" variant="danger"></b-spinner>
                </div>
              </div>
            </form>
          </div> <!-- card-body ends -->
        </div> <!-- card ends -->
      </div>
    </div>
  </section> <!-- /.content -->
</div><!-- ./wrapper -->
</template>

<script>
import Agenda from './js/agenda'
export default Agenda
</script>
